module.exports = __webpack_public_path__ + "static/media/manfred-2.4a55c360.jpg";